export default "__VITE_ASSET__3f8450ca__"